<div
  class="bg-white rounded-xl border border-slate-200 p-3 sm:p-4 flex flex-col gap-3 sm:gap-4 w-full sm:max-w-xs mx-auto h-full hover:shadow-md transition-shadow duration-150"
>
  <div class="flex items-center justify-between gap-2">
    <div class="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
      <div
        class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-bold text-base sm:text-lg shrink-0"
      >
        {{ empleado().nombre_completo | inicialesNombre }}
      </div>
      <div class="min-w-0 flex-1">
        <div class="font-semibold text-slate-800 text-sm sm:text-base leading-tight truncate">
          {{ empleado().nombre_completo }}
        </div>
        <div class="text-slate-500 text-xs sm:text-sm truncate">{{ permisos }}</div>
      </div>
    </div>
    <span
      class="text-xs font-semibold px-2 sm:px-3 py-1 rounded-full whitespace-nowrap shrink-0"
      [class.bg-green-100]="!empleado().deleted_at"
      [class.text-green-700]="!empleado().deleted_at"
      [class.bg-red-100]="empleado().deleted_at"
      [class.text-red-700]="empleado().deleted_at"
      >{{ empleado().deleted_at ? 'Inactivo' : 'Activo' }}</span
    >
  </div>
  <div class="flex flex-col gap-1 text-slate-600 text-xs sm:text-sm">
    <div class="flex items-center gap-2">
      <i class="bi bi-envelope text-sm sm:text-base"></i>
      <span class="break-all">{{ empleado().email }}</span>
    </div>
    <div class="flex items-center gap-2">
      <i class="bi bi-telephone text-sm sm:text-base"></i>
      <span>{{ empleado().telefono | telefono }}</span>
    </div>
  </div>
  <div class="flex flex-col sm:flex-row gap-2 mt-auto">
    <button
      class="flex-1 flex items-center justify-center gap-2 bg-accent-50 hover:bg-accent-100 text-accent-700 font-semibold py-2.5 rounded-lg transition active:scale-[0.98] text-xs sm:text-sm"
      (click)="modal_editar_empleado.set(true)"
    >
      <i class="bi bi-pencil"></i> Editar
    </button>
    @if (!empleado().deleted_at) {
      <button
        class="flex-1 flex items-center justify-center gap-2 bg-yellow-50 hover:bg-yellow-100 text-yellow-700 font-semibold py-2.5 rounded-lg transition active:scale-95 text-xs sm:text-sm"
        (click)="onStatus(false)"
      >
        <i class="bi bi-slash-circle"></i> Desactivar
      </button>
    } @else {
      <button
        class="flex-1 flex items-center justify-center gap-2 bg-green-50 hover:bg-green-100 text-green-700 font-semibold py-2.5 rounded-lg transition active:scale-95 text-xs sm:text-sm"
        (click)="onStatus(true)"
      >
        <i class="bi bi-check-circle"></i> Activar
      </button>
    }
  </div>
</div>
<app-dialog
  header="Editar Empleado"
  [modal]="true"
  [(visible)]="modal_editar_empleado"
  size="md"
>
  @if (modal_editar_empleado()) {
    <app-editar-empleado [empleado]="empleado()" (cerrar)="closeEditarEmpleado($event)" />
  }
</app-dialog>